const STORAGE_KEY = {
  /**
   * 请求环境配置
   */
  requestConfig: "REQUEST_CONFIG",
};

export default STORAGE_KEY;



// WEBPACK FOOTER //
// ./src/const/storage.js